import { apiFetch } from './client';

const BASE = '/segments';

/** List segments (paged). @param {{page?:number,size?:number,sort?:string,signal?:AbortSignal}} [opts] */
export const list = ({ page = 0, size = 20, sort = 'name,asc', signal } = {}) =>
  apiFetch(`${BASE}?page=${page}&size=${size}&sort=${sort}`, { signal });

/** Get a segment by id. */
export const get = (id, { signal } = {}) => apiFetch(`${BASE}/${id}`, { signal });

/** Create a segment. */
export const create = (body, { signal } = {}) =>
  apiFetch(BASE, { method: 'POST', body: JSON.stringify(body), signal });

/** Replace a segment (PUT semantics). */
export const update = (id, body, { signal } = {}) =>
  apiFetch(`${BASE}/${id}`, { method: 'PUT', body: JSON.stringify(body), signal });

/** Delete a segment. */
export const remove = (id, { signal } = {}) =>
  apiFetch(`${BASE}/${id}`, { method: 'DELETE', signal });
